import { useMemo } from "react";
import { useAuth } from "../../../hooks/auth";
import type { AgendaConsultant } from "../agendaTypes";
import {
  isConsultantRole,
  resolveConsultantProfile,
} from "../consultantMobileProfile";
import { useAgendaViewport } from "./useAgendaLayoutMode";

export function useConsultantMobileAgenda(consultants: AgendaConsultant[]) {
  const viewport = useAgendaViewport();
  const { user } = useAuth();

  const isConsultant = isConsultantRole(user?.role);
  const isConsultantMobileAgenda =
    viewport === "mobile" && isConsultant && user?.id != null;

  const consultantProfile = useMemo(() => {
    if (!user?.id) {
      return null;
    }
    return resolveConsultantProfile(
      {
        id: user.id,
        first_name: user.first_name,
      },
      consultants
    );
  }, [consultants, user?.first_name, user?.id]);

  const userFirstName = user?.first_name?.trim() || "Consultor";

  return {
    viewport,
    isConsultantMobileAgenda,
    consultantProfile,
    userFirstName,
  };
}
